<div class="form" [formGroup]="form" *ngIf="getIteration(data.slotSchedule, data.date)">
  <crm-wfm-file-upload-input
    [validationParseData]="timeWeightsValid"
    (uploadedData)="uploadTimeWeights($event)"
  ></crm-wfm-file-upload-input>
  <table
    mat-table
    multiTemplateDataRows
    [dataSource]="timeWeightsDataSource"
    [formArrayName]="forecastWeightsEnum.timeWeightsGroup"
  >
    <ng-container matColumnDef="{{ column }}" *ngFor="let column of timeWeightsColumnsToDisplay; let d = index">
      <th mat-header-cell *matHeaderCellDef>{{ column | transloco }}</th>
      <td mat-cell *matCellDef="let element; let s = dataIndex" [formGroupName]="s">
        <span class="row-title" *ngIf="d === 0">{{ element[d] }}</span>
        <div *ngIf="d !== 0">
          <input class="weight-block-weight-number" type="number" matInput [formControlName]="d - 1" />
          <mat-error *ngIf="isInvalid(s, d - 1)">
            {{ 'wfmModule.errors.incorrectValue' | transloco }}
          </mat-error>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="timeWeightsColumnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: timeWeightsColumnsToDisplay"></tr>
  </table>
</div>
